import React from "react";
import { useAppSelector, useAppDispatch } from "../../../../../../app/hooks";
import { formRegistry } from "../formRegistry";
import { savedCNYData } from "../../../../redux/formDataSlice";
import { useForm, SubmitHandler } from "react-hook-form";
import { FormInputs, CNYProps } from "../../../../../../types/walletTypes";

const Beneficiary = ({ handleNext, handlePrevious }: CNYProps) => {
  const getSavedData = useAppSelector((state) => state.formData.cnyData);
  const dispatch = useAppDispatch();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInputs>({ defaultValues: getSavedData });

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    dispatch(savedCNYData(data));
    handleNext?.();
  };

  const currentStep = "beneficiary";

  const CurrentStepComponent = formRegistry[currentStep]?.[
    getSavedData?.paymentMethod
  ] as any;

  if (!CurrentStepComponent) return null;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <CurrentStepComponent
        control={control}
        errors={errors}
        handleNext={handleNext}
        handlePrevious={handlePrevious}
      />
    </form>
  );
};

export default Beneficiary;
